export const CHANGE_DEAL_COLUMN_ACTION_TYPE = 'move-crm-deal';
export const DEAL_NOTE_MAX_LENGTH = 2000;
export const REQUEST_ESSENCE_MAX_LENGTH = 2250;
export const BUDGET_MAX_LENGHT = 15;
export const AREA_SQUARE_MAX_LENGHT = 15;
export const DEAL_NAME_MAX_LENGTH = 255;

export const POSTPONED_DEALS_SORT_FIELDS = ['postponed_until', 'last_contact_at'] as const;
export const IN_WORK_OR_FINISHED_DEALS_SORT_FIELDS = [
    'id',
    'next_contact_at',
    'payment_at',
] as const;
export const DEALS_SORT_DIRECTIONS = ['asc', 'desc'] as const;

export const DEFAULT_IN_WORK_OR_FINISHED_DEALS_SORT = 'id';
export const DEFAULT_IN_WORK_OR_FINISHED_DEALS_DIRECTION = 'desc';

export const POSTPONED_DEALS_QUERY_PARAM_API_KEYS = {
    page: 'page',
    limit: 'limit',
    query: 'query',
    sort: 'sort',
    direction: 'direction',
    postponedUntilFrom: 'postponed_until_from',
    postponedUntilTo: 'postponed_until_to',
    lastContactAtFrom: 'last_contact_at_from',
    lastContactAtTo: 'last_contact_at_to',
    areaFrom: 'area_from',
    areaTo: 'area_to',
} as const;

export const LOST_DEALS_QUERY_PARAM_API_KEYS = {
    page: 'page',
    limit: 'limit',
    query: 'query',
    sort: 'sort',
    direction: 'direction',
    lostAtFrom: 'lost_at_from',
    lostAtTo: 'lost_at_to',
} as const;

export const IN_WORK_OR_FINISHED_DEALS_QUERY_PARAM_API_KEYS = {
    page: 'page',
    limit: 'limit',
    query: 'query',
    showCompleted: 'show_completed',
    nextContactAtFrom: 'next_contact_at_from',
    nextContactAtTo: 'next_contact_at_to',
    paymentAtFrom: 'payment_at_from',
    paymentAtTo: 'payment_at_to',
    sort: 'sort',
    direction: 'direction',
} as const;

export const BUCKET_PLURALIZED_VARIANTS = {
    one: 'сделка',
    few: 'сделки',
    many: 'сделок',
};

export const DEFAULT_OBJECT_VALUE = '-'
